import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './firebase.config';
import { onAuthStateChanged } from 'firebase/auth'; // 👈 Import the listener

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 Add a loading state

  // Listen to Firebase Auth state changes
  useEffect(() => {
    // onAuthStateChanged returns an unsubscribe function
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user); // Set user to the user object from Firebase, or null if logged out
      setLoading(false); // Auth state has been checked, no longer loading
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []); // 👈 Empty dependency array ensures this runs only once

  const value = {
    currentUser,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;